import { observer } from "mobx-react-lite";
import * as React from "react";
import { Mk8sDraftMobx } from "../../../mst/stores/mk8s.draft";
import { NGFormElement } from "../../../newcomponents/ngformelement/ngformelement";
import { DryRunAlert } from "../dryRunAlert";
import { mk8sDryRun } from "../../../mobxStores/dryRun/mk8s";
import { NGButton } from "../../../newcomponents/button/Button";
import { mk8sMobx } from "../../../mst/kinds/mk8s/mk8s";

interface Props {
  mk8s: mk8sMobx;
  mk8sDraft: Mk8sDraftMobx;
}
const AddonsRegistryMirrorRaw: React.FC<Props> = ({ mk8s, mk8sDraft }) => {
  return (
    <div>
      <div className="mb-4">
        <DryRunAlert
          key={mk8sDryRun.key}
          canShow={true}
          dryRunResponse={mk8sDryRun.response}
          path={"spec.addOns.registryMirror"}
        />
      </div>
      <div className="flex items-center gap-4 mb-8">
        <div className="font-semibold">Registry Mirrors</div>
        <NGButton size={`small`} variant={"primary"} onClick={() => mk8sDraft.addon_registryMirror.addMirror()}>
          Add
        </NGButton>
      </div>
      {mk8sDraft.addon_registryMirror.mirrors.map((mainMirror, index) => {
        return (
          <div
            key={mainMirror.id}
            className={`${mk8sDraft.addon_registryMirror.mirrors.length - 1 === index ? "" : "border-b"} mb-6 pb-6`}
          >
            <div className="flex items-center gap-4 mb-2">
              <div className="font-semibold">Registry Config {index + 1}</div>
              <NGButton
                size={`small`}
                variant={"danger"}
                outlined
                onClick={() => mk8sDraft.addon_registryMirror.removeMirror(mainMirror.id)}
              >
                Remove
              </NGButton>
            </div>
            <div className="flex gap-2 items-start">
              <NGFormElement
                name={`mirrors[${index}].registry`}
                label={`Registry`}
                value={mainMirror.registry}
                required={true}
                onChange={mainMirror.setRegistry}
              />
              <div className="mt-6">
                <DryRunAlert
                  key={mk8sDryRun.key}
                  canShow={true}
                  dryRunResponse={mk8sDryRun.response}
                  onFix={mk8sDraft.addon_logs.includeNamespaces.setValue}
                  path={`spec.addOns.registryMirror.mirrors[${index}].registry`}
                />
              </div>
            </div>
            <div className="flex-1">
              {/* <NGInputListMst
                styles={{ container: { width: 450 } }}
                data={mainMirror.mirrors}
                firstInput={(item) => (
                  <NGInput value={item.firstValue} onChange={(e) => item.setFirstValue(e.target.value)} />
                )}
                label="Mirrors"
              /> */}
              <NGFormElement
                name={`mirrors[${index}].mirror`}
                label={`Mirror`}
                value={mainMirror.mirrors.items[0]?.firstValue || ""}
                onChange={(value) => {
                  mainMirror.mirrors.items[0]?.setFirstValue(value);
                }}
              />
              <div className="mt-2">
                <DryRunAlert
                  key={mk8sDryRun.key}
                  canShow={true}
                  dryRunResponse={mk8sDryRun.response}
                  path={`spec.addOns.registryMirror.mirrors[${index}].mirrors`}
                  paths={mainMirror.mirrors.items.map(
                    (_, i) => `spec.addOns.registryMirror.mirrors[${index}].mirrors[${i}]`,
                  )}
                />
              </div>
            </div>
            <DryRunAlert
              key={mk8sDryRun.key}
              canShow={true}
              dryRunResponse={mk8sDryRun.response}
              path={`spec.addOns.registryMirror.mirrors[${index}]`}
            />
          </div>
        );
      })}
    </div>
  );
};

export const AddonsRegistryMirror = observer(AddonsRegistryMirrorRaw);
